import { Component, Input } from '@angular/core';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, JsonPipe, SlicePipe } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { PipBaseStateComponent } from '../pip-base-state.component';
import { BaseRules, TextValues } from './kentucky.model';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-kentucky',
  templateUrl: './kentucky.component.html',
  styleUrls: ['./kentucky.component.scss'],
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    DropdownModule,
    CommonModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    JsonPipe,
    TruncateModule,
    TooltipModule,
  ],
})
export class KentuckyComponent extends PipBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('kentucky', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('kentucky', null);
    }
  }

  override dynamicRuleQueryBuilder(): string {
    return '';
  }
}
